import React, { useState } from 'react'
import { Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { PaginationModel } from 'utils/PaginationType'

export type SelectedRows = {
  type: 'include'
  ids: Set<number>
}

type ShireTableProps = {
  columns: any
  rows: any
  paginationModel: PaginationModel
  onPaginationModelChange: (paginationModel: PaginationModel) => void
  loading?: boolean
  onSelectionChange?: (selectedRows: any[]) => void
}

export default function ShireTable({
  columns,
  rows,
  paginationModel,
  onPaginationModelChange,
  loading,
  onSelectionChange,
}: ShireTableProps) {
  const [selectedRows, setSelectedRows] = useState<SelectedRows>({type: 'include', ids: new Set()});

  const handleSelectionChange = (newSelection: any) => {
    setSelectedRows({
      type: 'include',
      ids: new Set(newSelection.ids),
    });
    if (onSelectionChange) { 
      const selectedRowData: any[] = rows.filter((row: any) => newSelection.ids.has(row.id));
      onSelectionChange(selectedRowData);
    }
  };
  
  return (
    <Box sx={{ height: 'fit-content', width: '100%', marginTop: 2 }}>
      <DataGrid
        sx={{ width: '100%', overflowX: 'auto' }}
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: paginationModel.pageSize,
            },
          },
        }}
        pageSizeOptions={[5,10,20,50,100]}
        checkboxSelection={onSelectionChange !== undefined}
        disableRowSelectionOnClick
        loading={loading ?? false}
        paginationMode="server"
        rowCount={paginationModel.rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={(model) => onPaginationModelChange({
          page: model.page,
          pageSize: model.pageSize,
          rowCount: paginationModel.rowCount,
        })}
        onRowSelectionModelChange={handleSelectionChange}
        rowSelectionModel={selectedRows}
      />
    </Box>
  )
}